/**
 * budo_log 日志工具 在各前端项目中保持一致
 */

import moment from 'moment'
import axios from 'axios'

var ConsoleAppender = function (logArgs) {
  // 复制
  var args = Array.prototype.slice.call(logArgs.args)

  // 插入内容
  args.splice(0, 0, logArgs.message)

  // 插入级别
  args.splice(0, 0, logArgs.level)

  // 插入时间
  args.splice(0, 0, logArgs.moment)

  args.push(logArgs.href)

  // 输出
  console.warn(...args)
}

var isVue = function (input) {
  if (!input) {
    return false
  }

  if (input.mixin && input.component && input.mount) {
    return true
  }

  if (input.fullPath && input.matched && input.params) {
    return true
  }

  if (input._isVue || input.__v_isRef) {
    return true
  }

  if (input._mutations && input._vm && input._actions) {
    return true
  }

  try {
    JSON.stringify(input)
    return false
  } catch (e) {
    console.log("#31 isVue catch", e, input)
    return true
  }
}

var logKeys = function () {
  var keys = []

  const length = localStorage.length;
  for (let i = 0; i < length; i++) {
    const key = localStorage.key(i)
    if (!key) {
      continue
    }

    if (key.indexOf("budo_log_") == 0) {
      keys.push(key)
    }
  }

  return keys
}

var localStorage_removeItem = function (keys) {
  if (!keys) {
    console.log("#47 localStorage_removeItem", keys)
    return
  }

  for (let i = 0; i < keys.length; i++) {
    localStorage.removeItem(keys[i])
  }
}

var LocalStorageAppender = function (logArgs) {
  var key = "budo_log_" + moment(logArgs.moment).format("YYYYMMDD_HHmmss_SSS")

  // 有些东西不好序列化
  logArgs.args = logArgs.args.map(e => isVue(e) ? "VUE" : e)

  // 存起来
  localStorage.setItem(key, JSON.stringify(logArgs))

  // 请求过程中 响应后再下次请求
  if (window.LocalStorageAppender_POST) {
    return
  }

  var keys = logKeys()
  if (!keys || keys.length < 5) {
    return
  }

  // 请求过程中
  window.LocalStorageAppender_POST = true

  var logArray = []
  for (var i in keys) {
    logArray.push(localStorage.getItem(keys[i]))
  }

  // 非调试模式 不上传 DEBUG 日志
  if (!localStorage.getItem("budo.devmode.v2")) {
    logArray = logArray.filter(e => "DEBUG" != JSON.parse(e).level)
  }

  if (logArray.length < 1) {
    console.log("#47 logArray length 0, remove all")
    localStorage_removeItem(keys)
    window.LocalStorageAppender_POST = false
    return
  }

  axios({
    url: "/v5/js-log-post",
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    data: JSON.stringify(logArray)
  }).then(res => { // 已上传的就删除
    localStorage_removeItem(keys)

    console.log("#63 js-log-post done, len=", keys.length, res)

    window.LocalStorageAppender_POST = false
  }).catch(err => {
    console.log("#65 js-log-post err", err)

    window.LocalStorageAppender_POST = false
  })
}

window.budo_log = {
  _log_() {
    try {
      var logArgs = {
        level: arguments[1],
        href: location.href,
        moment: moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
        message: Array.prototype.slice.call(arguments, 2, 3)[0],
        args: Array.prototype.slice.call(arguments, 3)
      }

      var appenders = arguments[0]
      for (let i = 0; i < appenders.length; i++) {
        appenders[i](logArgs)
      }
    } catch (e) {
      console.log("#131 log err", e)
    }
  },

  error() {
    this._log_([ConsoleAppender, LocalStorageAppender], "ERROR", ...arguments)
  },

  warn() {
    this._log_([ConsoleAppender, LocalStorageAppender], "WARN", ...arguments)
  },

  info() {
    this._log_([ConsoleAppender, LocalStorageAppender], "INFO", ...arguments)
  },

  debug() {
    this._log_([ConsoleAppender, LocalStorageAppender], "DEBUG", ...arguments)
  }
}